import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-nowrap items-center gap-[12px]" }
const _hoisted_2 = { class: "flex flex-nowrap gap-[12px] items-center content-center" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import DurationFilter from '@/views/workloads/components/navbarComponents/durationFilter.vue';
import StatusFilter from '@/views/workloads/components/navbarComponents/statusFilter.vue';
import WorkloadTypeFilter from '@/views/workloads/components/navbarComponents/workloadTypeFilter.vue';
import BuildsGroupsFilter from '@/views/workloads/components/navbarComponents/buildGroupFilter.vue';
import { IncrediSearch } from 'incredi-ui';
import { computed, inject, onMounted, onUnmounted, ref } from 'vue';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { useMatomo } from '@/services/matomo/matomo.service';
import { useOsService } from '@/services/OsService/OsService';
import InitiatorTypeFilter from '@/views/workloads/components/navbarComponents/initiatorType.vue';
import EditWorkloadsTable from '@/views/workloads/components/navbarComponents/manageColumns/edit-workloads-table.vue';
import ExportBuildsCsvWrapper from '@/views/workloads/components/navbarComponents/exportBuildsCsvWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'workloadsTableNavbar',
  setup(__props) {

const workloadsPageData = inject(IKWorkloadsPageData);
const osService = useOsService();
const matomo = useMatomo();

const screenWidth = ref(window.innerWidth);
const maxExpandLength = computed(() => {
  if (screenWidth.value <= 1121) {
    return osService?.isWindows.value ? 280 : 310;
  }
  return osService?.isWindows.value ? 320 : 350;
});

const handleResize = () => {
  screenWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "flex flex-nowrap w-full justify-between" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(StatusFilter),
        _createVNode(DurationFilter),
        (_unref(osService)?.isWindows.value)
          ? (_openBlock(), _createBlock(InitiatorTypeFilter, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(BuildsGroupsFilter),
        (_unref(osService)?.isWindows.value)
          ? (_openBlock(), _createBlock(WorkloadTypeFilter, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(_unref(IncrediSearch), {
          "input-label": _unref(osService)?.isWindows.value ? _ctx.$t('workloads.workloadsTable.searchInputLabelWindows') : _ctx.$t('workloads.workloadsTable.searchInputLabelLinux'),
          "model-value": _unref(workloadsPageData)?.filter?.get?.value?.searchFilter || '',
          clearable: "",
          "max-expand-length": _unref(maxExpandLength),
          onClear: _cache[0] || (_cache[0] = ($event: any) => (_unref(workloadsPageData)?.filter?.setSearchFilter('', true))),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = (searchVal) => {
        _unref(workloadsPageData)?.filter?.setSearchFilter(searchVal, true);
        _unref(matomo)?.trackEvent({
          category: 'Workloads Search',
          action: 'Apply',
        });
      })
        }, null, 8, ["input-label", "model-value", "max-expand-length"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ExportBuildsCsvWrapper),
        _createVNode(EditWorkloadsTable, { class: "flex align-middle" })
      ])
    ]),
    _: 1
  }))
}
}

})